var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof grm_core_mfe !== "undefined") return resolve();
	__webpack_require__.l("https://wonderful-plant-0d1f23a0f.7.azurestaticapps.net/remoteEntry.js", (event) => {
		if(typeof grm_core_mfe !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "grm_core_mfe");
}).then(() => (grm_core_mfe));